import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CaseStatus } from '@vpfa/rest-api/valuation';
import { AdjustmentsFacade } from '@vpfa/dealer/case/data';
import { AmsPermissions } from '@vpfa/rest-api/admin';
import { camelCase, isNil } from 'lodash/fp';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'vpfa-price-adjustments-container-mobile',
  templateUrl: './price-adjustments-container-mobile.component.html',
  styleUrls: ['./price-adjustments-container-mobile.component.scss'],
})
export class PriceAdjustmentsContainerMobileComponent {
  @Input() isLoading: boolean;

  @Input() canMakeValuation: boolean;
  @Input() valuationNotAvailable: boolean;

  @Input() vehicleDetailsValue: string;
  @Input() repairAndMaintenanceValue: string;
  @Input() ownersCount: number;
  @Input() prospectCustomersCount: number;
  @Input() previousOwnersCount: any;
  @Input() caseStatus: CaseStatus;
  @Input() permissions: AmsPermissions;

  @Output() openVehicleDetails = new EventEmitter();
  @Output() openRepairAndMaintenance = new EventEmitter();
  @Output() openOwners = new EventEmitter();
  @Output() openProspectCustomers = new EventEmitter();
  @Output() openPreviousOwners = new EventEmitter();
  @Output() openNotes = new EventEmitter();
  @Output() openEquipment = new EventEmitter();
  CaseStatus = CaseStatus;

  equipmentTotal$ = this.adjustmentsFacade.getTotalEquipmentDeduction$;

  constructor(
    private adjustmentsFacade: AdjustmentsFacade,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  get notAvailable() {
    return !this.canMakeValuation || this.valuationNotAvailable;
  }

  openEquipmentPage() {
    this.router.navigate(['equipment'], { relativeTo: this.route });
  }

}
